/* Dave's Drum Shop — product-page widget presentation, v2.
   Safe scope: the product section only. No click handlers or checkout logic changed.
   App-owned widgets remain live. A read-only copy of Kangaroo text is shown only
   when an exact points sentence appears in the buying area. */
(function () {
  'use strict';
  var pointsPattern = /^by purchasing this item,?\s*loyalty members will earn [\d,]+ loyalty points\.?$/i;
  var extraStockPattern = /^only\s+(\d+)\s+available\.?$/i;
  var wishlistPattern = /(?:add to|remove from|save to|added to)\s+wish\s*list/i;
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function copyText(el) { return clean(el.textContent || el.value || ''); }
  function isPlain(el) {
    return el && !el.querySelector('button,a,input,select,textarea,[role="button"]');
  }
  function matchesWhole(el, regex) { return regex.test(copyText(el)); }
  function smallestMatch(root, regex) {
    var tags = root.querySelectorAll('p,span,small,strong,div:not(.dds-loyalty-summary)');
    for (var i=0; i<tags.length; i++) {
      var el = tags[i];
      if (el.classList.contains('dds-loyalty-summary') || !matchesWhole(el, regex) || !isPlain(el)) continue;
      var childMatches = Array.prototype.some.call(el.children, function (child) {
        return matchesWhole(child,regex);
      });
      if (!childMatches) return el;
    }
    return null;
  }
  function decorateWishlist(root) {
    var nodes = root.querySelectorAll('button,a,[role="button"],input[type="button"],input[type="submit"],[onclick]');
    Array.prototype.forEach.call(nodes, function (el) {
      var label = clean((el.getAttribute('aria-label') || '') + ' ' + (el.innerText || el.textContent || '') + ' ' + (el.value || ''));
      // Icons may be included in the text. Never style large containers with other actions.
      if (label.length > 150 || !wishlistPattern.test(label)) return;
      if (el.querySelector('button,a,[role="button"]')) return;
      el.classList.add('dds-wishlist-secondary');
    });
  }
  function decoratePoints(root) {
    var buy = root.querySelector('.product-info__block-item--buy-buttons');
    if (!buy) return;
    var source = smallestMatch(buy, pointsPattern);
    var existing = buy.querySelector('.dds-loyalty-summary');
    if (!source) {
      if (existing) existing.remove();
      return;
    }
    // Expand from leaf to the largest safe text-only element without leaving buy block.
    var parent = source.parentElement;
    while (parent && parent !== buy && isPlain(parent) && matchesWhole(parent,pointsPattern)) {
      source=parent;
      parent=source.parentElement;
    }
    source.classList.add('dds-loyalty-original-hidden');
    var purchaseText=copyText(source);
    if (!existing) {
      existing=document.createElement('p');
      existing.className='dds-loyalty-summary';
      buy.appendChild(existing);
    }
    if (existing.textContent !== purchaseText) existing.textContent=purchaseText;
  }
  function decorateStock(root) {
    var native = root.querySelector('.product-form__inventory');
    var isSingle = native && /only\s+1\s+unit\s+left/i.test(copyText(native));
    var list = root.querySelectorAll('.product-info__block-item--buy-buttons p, .product-info__block-item--buy-buttons div, .product-info__block-item--buy-buttons span');
    Array.prototype.forEach.call(list,function(el){
      if (!isPlain(el) || !matchesWhole(el,extraStockPattern)) return;
      if (isSingle) el.classList.add('dds-duplicate-stock-note');
      else el.classList.remove('dds-duplicate-stock-note');
    });
  }
  function decorateEmptyReviews(root) {
    var rating = root.querySelector('[data-block-id*="yotpo_product_reviews_ugc_star_rating"]');
    if (!rating) return;
    var message=copyText(rating);
    // Only a verified 0-review widget is hidden; non-zero reviews stay visible.
    if (/\b0\s+reviews?\b/i.test(message) && !/\b[1-9][\d,]*\s+reviews?\b/i.test(message)) {
      rating.classList.add('dds-no-reviews');
    } else {
      rating.classList.remove('dds-no-reviews');
    }
  }
  function init() {
    var section=document.querySelector('.dds-product-page');
    if (!section) return;
    var busy=false;
    function refresh() {
      if (busy) return;
      busy=true;
      try {
        var root=section.querySelector('.product-block-list__item--info');
        if (root) {
          decorateWishlist(root);
          decoratePoints(root);
          decorateStock(root);
          decorateEmptyReviews(root);
        }
      } finally { busy=false; }
    }
    refresh();
    // Product variant rerenders and app injections are observed within this one section.
    // Attribute changes made by our classes are intentionally NOT observed.
    var observer=new MutationObserver(refresh);
    observer.observe(section,{subtree:true,childList:true,characterData:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
